export default __webpack_public_path__ + "static/media/1.1fc3b504.png";